module.exports = __webpack_public_path__ + "02e129404762af7db1b7ce2cb5dba4a1.svg";